import { render, staticRenderFns } from "./StudentEvaluationsHistory.vue?vue&type=template&id=78e3b74c&"
import script from "./StudentEvaluationsHistory.vue?vue&type=script&lang=js&"
export * from "./StudentEvaluationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports